import { useState, useEffect } from 'react'
import { FranchiseService } from '../services/franchiseService'
import { FranchiseData } from '../config/api'

export const useFranchiseData = () => {
  const [franchiseData, setFranchiseData] = useState<FranchiseData | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchFranchiseData = async () => {
      try {
        setLoading(true)
        const service = FranchiseService.getInstance()
        const data = await service.getFranchiseData()
        setFranchiseData(data)
        
        // Apply dynamic styles
        service.applyDynamicStyles(data)
        
        // Update document title and meta tags
        document.title = `${data.name} - Travel & Holiday Packages`

        // Update meta description
        const metaDescription = document.querySelector('meta[name="description"]')
        if (metaDescription && data.catch_phrase) {
          metaDescription.setAttribute('content', `${data.name} - ${data.catch_phrase}. Transform your wanderlust into reality with personalized travel experiences.`)
        }

        // Update OG tags
        const ogTitle = document.querySelector('meta[property="og:title"]')
        if (ogTitle) {
          ogTitle.setAttribute('content', `${data.name} - Travel & Holiday Packages`)
        }

        const ogDescription = document.querySelector('meta[property="og:description"]')
        if (ogDescription && data.catch_phrase) {
          ogDescription.setAttribute('content', `${data.catch_phrase}. Transform your wanderlust into reality with personalized travel experiences.`)
        }

        // Update Twitter tags
        const twitterTitle = document.querySelector('meta[name="twitter:title"]')
        if (twitterTitle) {
          twitterTitle.setAttribute('content', `${data.name} - Travel & Holiday Packages`)
        }

        const twitterDescription = document.querySelector('meta[name="twitter:description"]')
        if (twitterDescription && data.catch_phrase) {
          twitterDescription.setAttribute('content', `${data.catch_phrase}. Transform your wanderlust into reality with personalized travel experiences.`)
        }
        
        setError(null)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch franchise data')
      } finally {
        setLoading(false)
      }
    }

    fetchFranchiseData()
  }, [])

  return { franchiseData, loading, error }
} 